// extracted by mini-css-extract-plugin
export var blue = "_22-g";
export var brand = "_22-c";
export var darkGrey = "_22-f";
export var disabled = "_22-5";
export var disabledSubtle = "_22-6";
export var error = "_22-7";
export var green = "_22-h";
export var grey = "_22-e";
export var icon = "_22-0";
export var inherit = "_22-b";
export var lightGrey = "_22-d";
export var orange = "_22-j";
export var pink = "_22-l";
export var primary = "_22-1";
export var purple = "_22-m";
export var quaternary = "_22-4";
export var red = "_22-k";
export var secondary = "_22-2";
export var success = "_22-a";
export var tertiary = "_22-3";
export var warning = "_22-8";
export var warningSecondary = "_22-9";
export var white = "_22-n";
export var yellow = "_22-i";